import React, { Component } from "react";
import { withRouter } from "react-router";
import { withAppContext } from "../../../store/contextStore";
import { Col, Row, Form, Input, Select, Checkbox, InputNumber } from "antd";
import Advertisement from "../../../common/Advertisement";

class BuyerPropertyFeatures extends Component {
  constructor(props) {
    super(props);

    this.state = {
      minArea: this.props.context.state.sellerHomeDetails.propertyFeatures
        ? this.props.context.state.sellerHomeDetails.propertyFeatures.minArea
        : "",
      maxArea: this.props.context.state.sellerHomeDetails.propertyFeatures
        ? this.props.context.state.sellerHomeDetails.propertyFeatures.maxArea
        : "",
      idealArea: "",
      idealBeds: "",
      idealBaths: "",
      prefillBeds: "",
      prefillBaths: "",
      idealPrice: "",
      showOnBuyersPage: false,
      matchingProfile: false,
      yearBuild: "",
      featuresOfchecked: this.props.context.state.sellerHomeDetails
        .propertyFeatures
        ? this.props.context.state.sellerHomeDetails.propertyFeatures
            .featuresOfchecked
        : [],
    };
  }
  onFinish = async (e) => {
    e["minArea"] = this.state.minArea || 0;
    e["maxArea"] = this.state.maxArea || 0;
    e["idealArea"] = this.state.idealArea || "";
    e["idealBeds"] = this.state.idealBeds || "";
    e["idealBaths"] = this.state.idealBaths || "";
    e["idealPrice"] = this.state.idealPrice || "";
    const buyerHomeDetails = this.props.buyerHomeDetails;
    const data =
      buyerHomeDetails &&
      buyerHomeDetails.buyerPropertyDetails &&
      buyerHomeDetails.buyerPropertyDetails;
    data["propertyType"] = e.propertyType;
    this.props.handleForm(data, "ADD_BUYER_GENERAL_FORM");
    // Pass checkbox state up to GeneraForm handler
    const details2 = {
      title: buyerHomeDetails && buyerHomeDetails.buyerPropertyDetails2 && buyerHomeDetails.buyerPropertyDetails2.title,
      showOnBuyersPage: !this.state.showOnBuyersPage,
      matchingProfile: this.state.matchingProfile,
    };
    this.props.handleForm(details2, "BUYER_PROPERTY_DETAILS2");
    this.props.handleForm(e, "ADD_BUYER_FEATURE_DETAIL_FORM", "saveBuyer");
  };
  onChangeMin = (value) => {
    this.setState({ minArea: value.target.value || "" });
  };
  onChangeMax = (value) => {
    this.setState({ maxArea: value.target.value || "" });
  };
  componentDidMount() {
    const { buyerHomeDetails } = this.props;
    if (buyerHomeDetails && buyerHomeDetails.buyerPropertyFeatures) {
      this.setState({
        maxArea: buyerHomeDetails.buyerPropertyFeatures.maxArea || "",
        minArea: buyerHomeDetails.buyerPropertyFeatures.minArea || "",
        idealArea: buyerHomeDetails.buyerPropertyFeatures.idealArea || "",
        idealBeds: buyerHomeDetails.buyerPropertyFeatures.idealBeds || "",
        idealBaths: buyerHomeDetails.buyerPropertyFeatures.idealBaths || "",
        idealPrice: buyerHomeDetails.buyerPropertyFeatures.idealPrice || "",
      });
    }
    if (buyerHomeDetails && buyerHomeDetails.buyerPropertyDetails2) {
      this.setState({
        showOnBuyersPage: !buyerHomeDetails.buyerPropertyDetails2.showOnBuyersPage,
        matchingProfile: buyerHomeDetails.buyerPropertyDetails2.matchingProfile || false,
      });
    }

    var prefill = JSON.parse(localStorage.getItem("prefillBuyerProfile") || "null");
    if (prefill) {
      var prefillState = {};
      if (prefill.minArea) prefillState.minArea = prefill.minArea;
      if (prefill.maxArea) prefillState.maxArea = prefill.maxArea;
      if (prefill.minbeds) prefillState.prefillBeds = parseInt(prefill.minbeds);
      if (prefill.minbaths) prefillState.prefillBaths = parseFloat(prefill.minbaths);
      if (Object.keys(prefillState).length > 0) this.setState(prefillState);
    }
  }

  handleFeaturesBox = (featuresOfchecked) => {
    this.setState({
      featuresOfchecked,
    });
  };

  handleToshowOnBuyerspage = (e) => {
    this.setState({ showOnBuyersPage: e.target.checked });
  };

  handleToMatchingProfile = (e) => {
    this.setState({ matchingProfile: e.target.checked });
  };

  render() {
    const DesiredBeds = [
      { label: "1+", value: 1 },
      { label: "2+", value: 2 },
      { label: "3+", value: 3 },
      { label: "4+", value: 4 },
      { label: "5+", value: 5 },
      { label: "6+", value: 6 },
      { label: "7+", value: 7 },
      { label: "8+", value: 8 },
      { label: "9+", value: 9 },
    ];
    const DesiredBaths = [
      { label: "1+", value: 1 },
      { label: "1.5+", value: 1.5 },
      { label: "2+", value: 2 },
      { label: "2.5+", value: 2.5 },
      { label: "3+", value: 3 },
      { label: "3.5+", value: 3.5 },
      { label: "4+", value: 4 },
      { label: "4.5+", value: 4.5 },
      { label: "5+", value: 5 },
    ];
    const yearBuiltOptions = [
      "1700-1920",
      "1920-1950",
      "1950-1980",
      "1990-2010",
      "2010+",
    ];
    const LotSizeOptionsForBuyerForm = [
      "0-0.5 acre",
      "0.5-1 acre",
      "1-2 acres",
      "2-5 acres",
      "5+ acres",
    ];
    const GarageSpaceSelction = ["1+", "2+", "3+"];
    const { maxArea, minArea } = this.state;
    const { buyerUserDetails, buyerHomeDetails } = this.props;
    const property1 = [
      { label: "Land", value: "Land" },
      { label: "Mobile Homes", value: "Mobile Homes" },
      {
        label: "Residential Multi Family Home",
        value: "Residential Multi Family Home",
      },
      {
        label: "Residential Single Family Home",
        value: "Residential Single Family Home",
      },
      { label: "Residential Rental ", value: "Residential Rental" },
      { label: "Residential Condominium", value: "Residential Condominium" },
      { label: "Coopertive", value: "Coopertive" },
      { label: "Commercial Office", value: "Commercial Office" },
      { label: "Commercial MLS", value: "Commercial MLS" },
      { label: "Business Opportunity", value: "Business Opportunity" },
    ];
    const FeaturesTags = [
      "Air Conditioning",
      "Fireplace",
      "Gym",
      "Laundry",
      "Outdoor Shower",
      "Sauna",
      "Shed",
      "Swimming Pool",
      "TV Cable",
      "Waterfront",
      "Wood Stove",
      "Walkout basement",
      "Fenced yard",
      "Fire pit",
      "Flat yard",
      "Wet bar",
      " Gas fireplace",
      "Walk in closet",
      "Screen porch",
      "Hardwood floors",
      "Granite counters",
      "Culdesac",
      "Hot Tub",
      "Sprinklers",
      "Central Vacuum",
      "Security System",
      "Walk-up Attic",
    ];

    const typeOfDwelling = [
      "Colonial",
      "Commercial",
      "Condo",
      "Contemporary",
      "Gambrel",
      "Multi Family",
      "Ranch",
      "Split Level",
      "Townhome",
      "Triple Decker",
    ];
    return (
      <div>
        <Row>
          {this.props && !this.props.BuyerProfile && (
            <Col
              xl={{ span: 24, offset: 0 }}
              lg={{ span: 24, offset: 0 }}
              md={{ span: 24, offset: 0 }}
              xs={{ span: 22, offset: 1 }}
              sm={{ span: 22, offset: 1 }}
            >
              <div className="privateD-title"></div>
              <div style={{ marginBottom: 20 }}>
                <span className="privateD-des"></span>
              </div>
            </Col>
          )}
          <Col
            xl={{
              span: this.props && this.props.BuyerProfile ? 22 : 16,
              offset: this.props && this.props.BuyerProfile ? 1 : 0,
            }}
            lg={{
              span: this.props && this.props.BuyerProfile ? 22 : 16,
              offset: this.props && this.props.BuyerProfile ? 1 : 0,
            }}
            md={{
              span: this.props && this.props.BuyerProfile ? 22 : 24,
              offset: this.props && this.props.BuyerProfile ? 1 : 0,
            }}
            xs={{
              span: this.props && this.props.BuyerProfile ? 24 : 22,
              offset: this.props && this.props.BuyerProfile ? 0 : 1,
            }}
            sm={{
              span: this.props && this.props.BuyerProfile ? 24 : 22,
              offset: this.props && this.props.BuyerProfile ? 0 : 1,
            }}
          >
            <Form
              initialValues={{ remember: true }}
              onFinish={this.onFinish}
              size="large"
              id="form"
            >
              <Row>
                <Col
                  xl={{ span: 11, offset: 0 }}
                  lg={{ span: 11, offset: 0 }}
                  md={{ span: 24, offset: 0 }}
                  xs={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                >
                  <div style={{ marginBottom: "8px" }}>
                    <div className="form-titles" style={{ marginBottom: "4px" }}>
                      Living Area <span style={{ color: "#888", fontWeight: 400, fontSize: "12px" }}>(optional — leave blank for no preference)</span>
                    </div>
                    <Row gutter={[8, 8]}>
                      <Col span={11}>
                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>Min sq.ft</div>
                        <Input
                          type="number"
                          addonAfter="sq.ft"
                          className="form-input-number-addonAfter"
                          value={minArea}
                          onChange={this.onChangeMin}
                          placeholder="0 (no min)"
                          step="Any"
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>Max sq.ft</div>
                        <Input
                          type="number"
                          addonAfter="sq.ft"
                          value={maxArea}
                          onChange={this.onChangeMax}
                          className="form-input-number-addonAfter"
                          placeholder="unlimited"
                          step="Any"
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "8px" }}>
                      <Col span={11}>
                        <div style={{ fontSize: "12px", color: "#1A2280", fontWeight: "600", marginBottom: "4px" }}>
                          ⭐ Ideal sq.ft <span style={{ color: "#888", fontWeight: 400 }}>(used for match scoring)</span>
                        </div>
                        <Input
                          type="number"
                          addonAfter="sq.ft"
                          className="form-input-number-addonAfter"
                          value={this.state.idealArea}
                          onChange={e => this.setState({ idealArea: e.target.value })}
                          placeholder="e.g. 2000"
                          step="Any"
                        />
                      </Col>
                    </Row>
                  </div>

                  <>
                    <div className="form-titles">Minimum Beds</div>
                    <Form.Item
                      name="beds"
                      initialValue={(() => {
                        if (buyerHomeDetails && buyerHomeDetails.buyerPropertyFeatures && buyerHomeDetails.buyerPropertyFeatures.beds) return buyerHomeDetails.buyerPropertyFeatures.beds;
                        var pf = JSON.parse(localStorage.getItem("prefillBuyerProfile") || "null");
                        return pf && pf.minbeds ? parseInt(pf.minbeds) : "";
                      })()}
                    >
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Select Desired Beds"
                      >
                        {DesiredBeds.map((province) => (
                          <Select.Option
                            key={province.value}
                            value={province.value}
                          >
                            {province.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                  <div style={{ fontSize: "12px", color: "#1A2280", fontWeight: "600", marginBottom: "4px", marginTop: "4px" }}>
                    ⭐ Ideal Beds <span style={{ color: "#888", fontWeight: 400 }}>(used for match scoring)</span>
                  </div>
                  <Select
                    style={{ width: "100%", marginBottom: "12px" }}
                    placeholder="Ideal number of beds"
                    value={this.state.idealBeds || undefined}
                    onChange={v => this.setState({ idealBeds: v })}
                  >
                    {[1,2,3,4,5,6].map(n => (
                      <Select.Option key={n} value={n}>{n} beds</Select.Option>
                    ))}
                  </Select>
                  <div className="form-titles">Minimum Baths</div>
                  <Form.Item
                    name="baths"
                    initialValue={(() => {
                      if (buyerHomeDetails && buyerHomeDetails.buyerPropertyFeatures && buyerHomeDetails.buyerPropertyFeatures.baths) return buyerHomeDetails.buyerPropertyFeatures.baths;
                      var pf = JSON.parse(localStorage.getItem("prefillBuyerProfile") || "null");
                      return pf && pf.minbaths ? parseFloat(pf.minbaths) : "";
                    })()}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Desired Baths"
                    >
                      {DesiredBaths.map((province) => (
                        <Select.Option
                          key={province.value}
                          value={province.value}
                        >
                          {province.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div style={{ fontSize: "12px", color: "#1A2280", fontWeight: "600", marginBottom: "4px", marginTop: "4px" }}>
                    ⭐ Ideal Baths <span style={{ color: "#888", fontWeight: 400 }}>(used for match scoring)</span>
                  </div>
                  <Select
                    style={{ width: "100%", marginBottom: "12px" }}
                    placeholder="Ideal number of baths"
                    value={this.state.idealBaths || undefined}
                    onChange={v => this.setState({ idealBaths: v })}
                  >
                    {[1,1.5,2,2.5,3,3.5,4].map(n => (
                      <Select.Option key={n} value={n}>{n} baths</Select.Option>
                    ))}
                  </Select>
                  <div className="form-titles">Desired Type of Dwelling</div>
                  <Form.Item
                    name="dwelling"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.dwelling
                        ? buyerHomeDetails.buyerPropertyFeatures.dwelling
                        : []
                    }
                  >
                    <Select
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Select Type Of Dwelling"
                      mode={
                        this.props.AddBuyer || this.props.BuyerProfile
                          ? "multiple"
                          : ""
                      }
                    >
                      {typeOfDwelling.map((province) => (
                        <Select.Option key={province} value={province}>
                          {province}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div className="form-titles">Desired Garage</div>
                  <Form.Item
                    name="garageSpace"
                    initialValue={
                      buyerHomeDetails && buyerHomeDetails.buyerPropertyFeatures
                        ? buyerHomeDetails.buyerPropertyFeatures.garageSpace
                        : ""
                    }
                  >
                    <Select placeholder="Select">
                      {GarageSpaceSelction.map((province) => (
                        <Select.Option key={province} value={province}>
                          {province}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div className="form-titles">Desired Year Built</div>
                  <Form.Item
                    name="yearBuilt"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.yearBuilt
                        ? buyerHomeDetails.buyerPropertyFeatures.yearBuilt
                        : []
                    }
                  >
                    <Select
                      placeholder="You can select multiple"
                      mode="multiple"
                      allowClear
                    >
                      {yearBuiltOptions.map((province) => (
                        <Select.Option key={province} value={province}>
                          {province}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div className="form-titles">Desired Condition</div>
                  <Form.Item
                    name="condition"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.condition
                        ? buyerHomeDetails.buyerPropertyFeatures.condition
                        : []
                    }
                  >
                    <Select
                      className="form-input"
                      placeholder="Select Condition"
                      mode={
                        this.props.AddBuyer || this.props.BuyerProfile
                          ? "multiple"
                          : ""
                      }
                    >
                      <Select.Option value="Poor">Poor</Select.Option>
                      <Select.Option value="Fair">Fair</Select.Option>
                      <Select.Option value="Average">Average</Select.Option>
                      <Select.Option value="Good">Good</Select.Option>
                      <Select.Option value="Excellent">Excellent</Select.Option>
                      <Select.Option value="Brand New">Brand New</Select.Option>
                    </Select>
                  </Form.Item>
                  <div className="form-titles">Desired Basement</div>
                  <Form.Item
                    name="basement"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.basement
                        ? buyerHomeDetails.buyerPropertyFeatures.basement
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col
                  xl={{ span: 11, offset: 1 }}
                  lg={{ span: 11, offset: 1 }}
                  md={{ span: 24, offset: 0 }}
                  xs={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                >
                  <>
                  <div style={{ fontSize: "12px", color: "#1A2280", fontWeight: "600", marginBottom: "4px" }}>
                    ⭐ Ideal Price <span style={{ color: "#888", fontWeight: 400 }}>(used for match scoring — separate from your search range)</span>
                  </div>
                  <Input
                    prefix="$"
                    placeholder="e.g. 550000"
                    value={this.state.idealPrice}
                    onChange={e => this.setState({ idealPrice: e.target.value })}
                    style={{ marginBottom: "16px", borderRadius: "6px" }}
                  />
                    <div className="form-titles">Property Type</div>
                    <Form.Item
                      name="propertyType"
                      initialValue={
                        buyerHomeDetails &&
                        buyerHomeDetails.buyerPropertyFeatures &&
                        buyerHomeDetails.buyerPropertyFeatures.propertyType
                          ? buyerHomeDetails.buyerPropertyFeatures.propertyType
                          : []
                      }
                    >
                      <Select placeholder="Select" mode={"multiple"} allowClear>
                        {property1.map((province) => (
                          <Select.Option
                            multiple
                            key={province.value}
                            value={province.value}
                          >
                            {province.value}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                  <div className="form-titles">Desired Lot Size</div>
                  <Form.Item
                    name="LotSize"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.LotSize
                        ? buyerHomeDetails.buyerPropertyFeatures.LotSize
                        : []
                    }
                  >
                    <Select placeholder="Select" mode="multiple">
                      {LotSizeOptionsForBuyerForm.map((province) => (
                        <Select.Option key={province} value={province}>
                          {province}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <div className="form-titles">Desired Cooling</div>
                  <Form.Item
                    name="colling"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.colling
                        ? buyerHomeDetails.buyerPropertyFeatures.colling
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                  <div className="form-titles">Desired Heating</div>
                  <Form.Item
                    name="heating"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.heating
                        ? buyerHomeDetails.buyerPropertyFeatures.heating
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                  <div className="form-titles">Desired Utilities</div>
                  <Form.Item
                    name="utilities"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.utilities
                        ? buyerHomeDetails.buyerPropertyFeatures.utilities
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                  <div className="form-titles">Desired Interior Features</div>
                  <Form.Item
                    name="interiorFeatures"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.interiorFeatures
                        ? buyerHomeDetails.buyerPropertyFeatures
                            .interiorFeatures
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                  <div className="form-titles">Desired Exterior Features</div>
                  <Form.Item
                    name="exteriorFeatures"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.interiorFeatures
                        ? buyerHomeDetails.buyerPropertyFeatures
                            .interiorFeatures
                        : []
                    }
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col
                  xl={{ span: this.props.BuyerProfile ? 23 : 23 }}
                  lg={{ span: this.props.BuyerProfile ? 23 : 23 }}
                  md={{ span: this.props.BuyerProfile ? 23 : 23 }}
                  xs={{ span: this.props.BuyerProfile ? 24 : 24 }}
                  sm={{ span: this.props.BuyerProfile ? 24 : 24 }}
                >
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: "600",
                      fontFamily: "Poppins,sans-serif",
                    }}
                  >
                    Desired Features
                  </div>
                  <Form.Item
                    name="featuresOfchecked"
                    initialValue={
                      buyerHomeDetails &&
                      buyerHomeDetails.buyerPropertyFeatures &&
                      buyerHomeDetails.buyerPropertyFeatures.featuresOfchecked
                        ? buyerHomeDetails.buyerPropertyFeatures
                            .featuresOfchecked
                        : []
                    }
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="You Can Select Multiple Features"
                    >
                      {FeaturesTags.map((province) => (
                        <Select.Option key={province} value={province}>
                          {province}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* ── ALERTS & PRIVACY — last step ─────────────────────────── */}
              <Row style={{ marginTop: "24px", padding: "16px", background: "#f0f4ff", borderRadius: "10px" }}>
                <Col span={24}>
                  <div style={{ fontWeight: "700", color: "#1A2280", marginBottom: "12px", fontSize: "14px" }}>
                    Profile Settings
                  </div>
                  <Form.Item name="showOnBuyersPage">
                    <Checkbox
                      onChange={this.handleToshowOnBuyerspage}
                      checked={this.state.showOnBuyersPage}
                    >
                      <span className="form-titles">
                        Mark as Private — this profile will not be visible on the public buyers list page
                      </span>
                    </Checkbox>
                  </Form.Item>
                  <Form.Item name="matchingProfile">
                    <Checkbox
                      onChange={this.handleToMatchingProfile}
                      checked={this.state.matchingProfile}
                    >
                      <span className="form-titles">
                        Send me alerts when new on and off MLS properties hit the market matching this profile
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

            </Form>
          </Col>
          {this.props && !this.props.BuyerProfile && (
            <Col
              xl={{ span: 7, offset: 1 }}
              lg={{ span: 7, offset: 1 }}
              md={{ span: 24, offset: 0 }}
              xs={{ span: 22, offset: 1 }}
              sm={{ span: 22, offset: 1 }}
            >
              <Advertisement
                otherAds={false}
                adType="Square"
                adWhereToShow="Buyers"
                adLimit="3"
                zipCode=""
              />
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export default withAppContext(withRouter(BuyerPropertyFeatures));
